export default "__VITE_ASSET__CoBRD2Q8__"